export default "__VITE_ASSET__DryNhUus__"